import type { OnboardingV3ResultValues } from "./onboardingV3Types";
import {
  MOCK_MONEY_LEAK_BUCKETS,
  MOCK_PORTFOLIO_RISK_SLICES,
} from "./buildEstimateResultValues";

/** V3.0.6 estimate Result fixtures — tests + L3 only; never written to session. */
export const ONBOARDING_V306_RESULT_FIXTURES: Record<
  "money-leak" | "portfolio-risk",
  OnboardingV3ResultValues
> = {
  "money-leak": {
    goalType: "spending",
    values: {
      mode: "estimate_two_bucket",
      hero: {
        annualSaveOpportunity: 15_120,
        monthlySaveOpportunity: 1_260,
      },
      chart: {
        current: [
          {
            bucket: "expenses",
            amount: 6200,
            ratePct: MOCK_MONEY_LEAK_BUCKETS.yours.spending,
          },
          {
            bucket: "remaining",
            amount: 1200,
            ratePct: MOCK_MONEY_LEAK_BUCKETS.yours.save,
          },
        ],
        target: [
          {
            bucket: "fixed",
            amount: 4950,
            ratePct: MOCK_MONEY_LEAK_BUCKETS.target.fixed,
          },
          {
            bucket: "save",
            amount: 1800,
            ratePct: MOCK_MONEY_LEAK_BUCKETS.target.save,
          },
          {
            bucket: "spending",
            amount: 2250,
            ratePct: MOCK_MONEY_LEAK_BUCKETS.target.spending,
          },
        ],
      },
      // harness / legacy dual-read
      annualSavings: 15_120,
      monthlySavings: 1_260,
      yoursBuckets: MOCK_MONEY_LEAK_BUCKETS.yours,
      targetBuckets: MOCK_MONEY_LEAK_BUCKETS.target,
      goalRampLine1: "Get your saving to 20% of what lands",
      goalRampLine2: "$1,260 a month",
    },
  },
  "portfolio-risk": {
    goalType: "invest",
    values: {
      hero: {
        topHoldingName: "Largest visible holding",
        topHoldingWeightPct: MOCK_PORTFOLIO_RISK_SLICES.topWeight,
        guardrailWeightPct: 15,
        alreadyWithinGuardrail: false,
      },
      coverage: {
        includedMarketValue: 220_000,
        balanceOnlyMarketValue: 0,
        includedAccountCount: 2,
        balanceOnlyAccountCount: 0,
        positionCount: 8,
        complete: true,
        disclosure: null,
      },
      chart: {
        before: MOCK_PORTFOLIO_RISK_SLICES.before.map((slice, index) => ({
          key: slice.id,
          label: slice.label,
          marketValue: slice.weight * 1000,
          weightPct: slice.weight,
          highlighted: index === 0,
        })),
        after: MOCK_PORTFOLIO_RISK_SLICES.after.map((slice, index) => ({
          key: slice.id,
          label: slice.label,
          weightPct: slice.weight,
          highlighted: index === 0,
        })),
        caption: "Same money, spread differently",
      },
      backtest: null,
      topWeight: MOCK_PORTFOLIO_RISK_SLICES.topWeight,
      withEdTopWeight: MOCK_PORTFOLIO_RISK_SLICES.withEdTopWeight,
      beforeSlices: MOCK_PORTFOLIO_RISK_SLICES.before,
      afterSlices: MOCK_PORTFOLIO_RISK_SLICES.after,
      goalRampLine1: "Bring single-name concentration into your 15% guardrail",
      goalRampLine2: "Staged over 6 months",
    },
  },
};
